'use client';
import Image, { ImageProps } from "next/image";
import { useEffect, useState, useMemo, memo } from "react";
import { twMerge } from "tailwind-merge";


interface Props extends ImageProps {
  eager?: boolean;
  forceUpdate?: boolean; 
  isUser?: boolean;
  thumbnail?: string; 
  device?: string;
  customDimensions?: Partial<{
    height: number;
    width: number;
    fit: 'cover' | 'contain';
  }>;
}


const getResizedImageUrl = (src: string, options: Props['customDimensions'] = {}) => {
  const base = new URL(`https://erem-media-service.azurewebsites.net/api/ResizeImage`);
  base.searchParams.set('image', src);
  const {height, width, fit} = options;
  if (height) base.searchParams.set('height', String(height));
  if (width) base.searchParams.set('width', String(width));
  if (fit) base.searchParams.set('fit', fit);
  return base.href;
}

const extensions = ['.webp', ''];

const filterExtension = (src: string) => {
  let result = src;
  extensions.forEach(e => result.replace(e, ''));
  return result;
}

const  FallBackImage = ({ src, alt, forceUpdate, thumbnail, device, isUser, customDimensions, ...rest }: Props) => {
  const placeholderImageSrc = isUser ? '/assets/images/user-default-image.png' : '/assets/images/default-image.png';
const placeholderImage = {src: placeholderImageSrc, thumbnail: placeholderImageSrc};
  let srcs = src ?  extensions.map(e => ({src: `${filterExtension(src as string)}${e}`, thumbnail: thumbnail ? `${filterExtension(thumbnail as string)}${e}` : placeholderImage.thumbnail})).concat(placeholderImage) : [placeholderImage];
  const [{ selected, index }, setState] = useState<{ selected: {src: string; thumbnail: string}; index: number; }>(({ selected: srcs[0], index: 0 }));
  const isDesktop = device === 'desktop';
  useEffect(() => {
    if (!forceUpdate) {
      if (!src) {
        setState(prevState => ({...prevState,selected: srcs[0]}));
      }
      return;
    }
    srcs = src ?  extensions.map(e => ({src: `${filterExtension(src as string)}${e}`, thumbnail: thumbnail ? `${filterExtension(thumbnail as string)}${e}` : placeholderImage.thumbnail})).concat(placeholderImage) : [placeholderImage];
    setState({ selected: srcs[0], index: 0 });
  }, [src]);


  const eager = rest.loading === 'eager' || rest.priority || rest.eager;
  //@ts-ignore
  ['priority', 'loading', 'sizes', 'fill'].forEach(x => delete rest[x]);

  const props: any = {
    ...rest,
    fill: true,
    sizes: '100vw',
    className: twMerge(rest.className, 'absolute top-0 left-0'),
    onError: () => {
      const isLast = index === srcs.length - 1;
      if (isLast) return;
      setState(prevState => ({ ...prevState, selected: srcs[index + 1], index: prevState.index + 1 }))
    },
    alt,
  }


  let finalSrc = selected.src;
  const isPlaceholder = selected.src === placeholderImageSrc;
  if (!isDesktop) {
    if (customDimensions && !isPlaceholder) finalSrc = getResizedImageUrl(selected.src, customDimensions);
    else finalSrc = selected.thumbnail;
  }
  

  return (
    <>
      <Image {...props} src={finalSrc} priority={Boolean(eager)} loading={eager ? 'eager' : 'lazy'} fetchPriority={eager ? 'high' : 'low'}/> 

    </>
  )
}

export default memo(FallBackImage);
